import { render, staticRenderFns } from "./CreateOrUpdateSurvey.vue?vue&type=template&id=8f279db8&"
import script from "./CreateOrUpdateSurvey.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports